import React from "react";
import {
    FiX, FiUser, FiPhone, FiMail, FiCalendar, FiTag, FiSave,
    FiAlertCircle
} from "react-icons/fi";

const EditCustomerModal = ({
                               visible,
                               onClose,
                               formData,
                               onChange,
                               onSave,
                               submitting,
                               modalError,
                               setModalError,
                           }) => {
    if (!visible) return null;

    return (
        <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-navy-900/60 backdrop-blur-md">
            <div
                className="bg-white dark:bg-navy-800 rounded-3xl shadow-2xl w-full max-w-lg max-h-[92vh] flex flex-col overflow-hidden"
                style={{ animation: "scaleIn 0.2s ease-out" }}
            >
                {/* Header */}
                <div className="px-6 py-5 border-b border-gray-100 dark:border-navy-700 flex items-center justify-between bg-gray-50 dark:bg-navy-900">
                    <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-xl bg-brand-100 dark:bg-brand-900/30 flex items-center justify-center">
                            <FiUser className="text-brand-500" size={17} />
                        </div>
                        <h2 className="text-lg font-bold text-navy-700 dark:text-white">Müşteri Düzenle</h2>
                    </div>
                    <button
                        onClick={onClose}
                        className="p-2 rounded-xl text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 transition-all"
                    >
                        <FiX size={20} />
                    </button>
                </div>

                {/* Body */}
                <div className="flex-1 overflow-y-auto p-6 space-y-4" style={{ scrollbarWidth: "thin" }}>
                    {/* Hata */}
                    {modalError && (
                        <div className="flex items-center gap-3 p-4 bg-red-50 dark:bg-red-900/10 border border-red-200 dark:border-red-800/40 rounded-2xl">
                            <FiAlertCircle className="text-red-500 shrink-0" size={18} />
                            <p className="text-sm text-red-600 dark:text-red-400 font-medium flex-1">{modalError}</p>
                            <button onClick={() => setModalError(null)} className="text-red-400 hover:text-red-600 transition-colors">
                                <FiX size={15} />
                            </button>
                        </div>
                    )}

                    {/* Ad - Soyad */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">
                                Ad *
                            </label>
                            <div className="relative">
                                <FiUser className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" size={14} />
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={onChange}
                                    placeholder="İsim"
                                    className="w-full bg-white dark:bg-navy-900 border border-gray-200 dark:border-navy-600 rounded-xl pl-9 pr-4 py-3 text-sm text-navy-700 dark:text-white outline-none focus:border-brand-500 transition-all"
                                />
                            </div>
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">
                                Soyad *
                            </label>
                            <div className="relative">
                                <FiUser className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" size={14} />
                                <input
                                    type="text"
                                    name="surname"
                                    value={formData.surname}
                                    onChange={onChange}
                                    placeholder="Soyisim"
                                    className="w-full bg-white dark:bg-navy-900 border border-gray-200 dark:border-navy-600 rounded-xl pl-9 pr-4 py-3 text-sm text-navy-700 dark:text-white outline-none focus:border-brand-500 transition-all"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Telefon - Email */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">
                                Telefon *
                            </label>
                            <div className="relative">
                                <FiPhone className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" size={14} />
                                <input
                                    type="text"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={onChange}
                                    placeholder="+905xxxxxxxxx"
                                    className="w-full bg-white dark:bg-navy-900 border border-gray-200 dark:border-navy-600 rounded-xl pl-9 pr-4 py-3 text-sm text-navy-700 dark:text-white outline-none focus:border-brand-500 transition-all"
                                />
                            </div>
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">
                                E-posta
                            </label>
                            <div className="relative">
                                <FiMail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" size={14} />
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={onChange}
                                    placeholder="ornek@mail.com"
                                    className="w-full bg-white dark:bg-navy-900 border border-gray-200 dark:border-navy-600 rounded-xl pl-9 pr-4 py-3 text-sm text-navy-700 dark:text-white outline-none focus:border-brand-500 transition-all"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Doğum tarihi - Etiket */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">
                                Doğum Tarihi
                            </label>
                            <div className="relative">
                                <FiCalendar className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" size={14} />
                                <input
                                    type="date"
                                    name="birth_date"
                                    value={formData.birth_date}
                                    onChange={onChange}
                                    className="w-full bg-white dark:bg-navy-900 border border-gray-200 dark:border-navy-600 rounded-xl pl-9 pr-4 py-3 text-sm text-navy-700 dark:text-white outline-none focus:border-brand-500 transition-all"
                                />
                            </div>
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">
                                Etiket <span className="text-gray-400 font-normal">(Opsiyonel)</span>
                            </label>
                            <div className="relative">
                                <FiTag className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" size={14} />
                                <input
                                    type="text"
                                    name="tag"
                                    value={formData.tag}
                                    onChange={onChange}
                                    placeholder="Örn: VIP, Potansiyel"
                                    className="w-full bg-white dark:bg-navy-900 border border-gray-200 dark:border-navy-600 rounded-xl pl-9 pr-4 py-3 text-sm text-navy-700 dark:text-white outline-none focus:border-brand-500 transition-all"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="px-6 py-4 border-t border-gray-100 dark:border-navy-700 bg-gray-50 dark:bg-navy-900 flex gap-3 justify-end">
                    <button
                        onClick={onClose}
                        disabled={submitting}
                        className="px-5 py-2.5 rounded-xl text-sm font-bold text-gray-500 dark:text-gray-400 bg-white dark:bg-navy-800 border border-gray-200 dark:border-navy-600 hover:bg-gray-100 dark:hover:bg-navy-700 transition-all disabled:opacity-50"
                    >
                        İptal
                    </button>
                    <button
                        onClick={onSave}
                        disabled={submitting}
                        className="flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-bold text-white bg-brand-500 hover:bg-brand-600 shadow-lg shadow-brand-500/30 transition-all disabled:opacity-60"
                    >
                        {submitting ? (
                            <><div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div> Kaydediliyor...</>
                        ) : (
                            <><FiSave size={15} /> Kaydet</>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EditCustomerModal;